import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';

import { UserContext } from '~/components/providers/UserProvider';

import { STALE_TIME } from '../constants/query';
import { getMarketAccount } from '../services/account.service.api';

import { useMarketAccountQueryKey } from './useMarketAccountQueryKey';

export const useMarketAccountSettings = () => {
  const { userId } = useContext(UserContext);

  return useQuery({
    queryKey: useMarketAccountQueryKey(),
    queryFn: () => getMarketAccount(),
    staleTime: STALE_TIME,
    refetchInterval: 30 * 60 * 1000,
    keepPreviousData: true,
    enabled: !!userId,
  });
};
